<template>
  <div class="text-left">
    <div class="row">
      <div class="col col-sm-12">
        <h3 class="font-weight-bolder mt-2">Personal Information</h3>
        <button
          class="btn btn-sm btn-xs btn-outline-secondary font-weight-bolder"
          data-toggle="modal"
          data-target="#setVessel"
          v-if="crew.active == 1 || isSystemAdmin"
        >
          <span class="fas fa-file-alt"></span>
          CMS Biodata
        </button>

        <div class="row mt-2 text-small">
          <div class="col col-sm-6 p-2">
            <crew-info></crew-info>
            <general-info></general-info>
          </div>

          <div class="col col-sm-6 p-2">
            <agency-numbers></agency-numbers>
            <language></language>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="setVessel"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Custom Biodata</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="exampleFormControlInput1">Work Experience</label>
              <input
                type="number"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="Default All"
                min="0"
                v-model="biodata.experience"
              />
            </div>

            <!-- <div>
              <label class="typo__label">Work Experience</label>
              <multiselect
                v-model="biodata.experience"
                :options="crewExperienceOptions"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="-- Select --"
                label="name"
                track-by="value"
                :preselect-first="true"
              >
                <template
                  slot="selection"
                  slot-scope="{ values, search, isOpen }"
                  ><span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }} options selected</span
                  ></template
                >
              </multiselect>
            </div> -->
            <div class="mt-2">
              <label class="typo__label">Vessel Type</label>
              <multiselect
                v-model="biodata.vesselType"
                :options="vesselTypeKeys"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="-- Select --"
                label="name"
                track-by="id"
                :preselect-first="false"
              >
                <template
                  slot="selection"
                  slot-scope="{ values, search, isOpen }"
                  ><span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }} options selected</span
                  ></template
                >
              </multiselect>
            </div>

            <div class="mt-2">
              <label class="typo__label">Vessel Flag</label>
              <multiselect
                v-model="biodata.vesselFlag"
                :options="countryKeys"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="-- Select --"
                label="name"
                track-by="id"
                :preselect-first="false"
              >
                <template
                  slot="selection"
                  slot-scope="{ values, search, isOpen }"
                  ><span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                    >{{ values.length }} options selected</span
                  ></template
                >
              </multiselect>
            </div>

            <div class="custom-control custom-checkbox mt-2">
              <input
                type="checkbox"
                class="custom-control-input"
                id="customCheck1"
                v-model="biodata.withPromotion"
              />
              <label class="custom-control-label" for="customCheck1"
                >With Promotion</label
              >
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="generateBiodata"
              class="btn btn-primary"
            >
              Generate Biodata
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CrewInfo from "./personal_info/CrewInfo";
import GeneralInfo from "./personal_info/GeneralInfo";
import AgencyNumbers from "./personal_info/AgencyNumbers";
import Language from "./personal_info/Language";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import { GlobalService } from "@/services/GlobalService";
import { mapActions, mapGetters, mapState } from "vuex";
import {gateMixin} from "@/mixins/gateMixin";

export default {
  name: "CrewPersonal",
  mixins: [gateMixin],
  components: { CrewInfo, GeneralInfo, AgencyNumbers, Language, Multiselect },
  data() {
    return {
      biodata: {
        experience: null,
        vesselType: [],
        vesselFlag: [],
        withPromotion: false,
      },
      crewExperienceOptions: [
        { name: "All", value: null },
        { name: "10", value: 10 },
        { name: "25", value: 25 },
        { name: "50", value: 50 },
      ],
    };
  },
  methods: {
    ...mapActions(["getVesselTypeKeys", "getCountryKeys"]),
    async init() {
      await this.getVesselTypeKeys();
      await this.getCountryKeys();
    },
    serializeBiodata() {
      return {
          // sea_service_limit: this.biodata.experience.value,
        sea_service_limit: this.biodata.experience,
        vessel_type_id: Object.keys(this.biodata.vesselType).map(
          (vesselTypeIndex) => {
            return this.biodata.vesselType[vesselTypeIndex].id;
          }
        ),
        vessel_flag_id: Object.keys(this.biodata.vesselFlag).map(
          (vesselFlagIndex) => {
            return this.biodata.vesselFlag[vesselFlagIndex].id;
          }
        ),
        is_with_promotion: this.biodata.withPromotion,
        crew_id: this.$route.params.id,
      };
    },
    async generateBiodata() {
      let pleaseWait = Swal.fire({
        text: "Please wait...",
        showCancelButton: false,
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      await this.$store
        .dispatch("CrewBiodataModule/generateBiodata", this.serializeBiodata())
        .then((res) => {
          const pdf = res.data.biodata;

          fetch(`data:application/pdf;base64,${pdf}`)
            .then((res) => res.blob())
            .then((blob) => {
              var url = window.URL.createObjectURL(blob);
              window.open(url);
            });
        })
        .catch((error) => {
          return GlobalService.handleError(error, "Generate Biodata");
        })
        .then(() => {
          pleaseWait.close();
        });
    },
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters(["vesselTypeKeys", "countryKeys", 'crew']),
  },
};
</script>

<style scoped>
.border-black {
  border: 1px solid black !important;
  border-radius: 5px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
